<template>
	<el-form ref="resetForm" :model="resetForm" :rules="resetRules" class="login-form" label-width="0" status-icon>
		<el-form-item prop="password1">
			<el-input
				v-model="resetForm.password1"
				:type="password1Type"
				auto-complete="off"
				placeholder="请输入密码"
				prefix-icon="el-icon-lock"
				size="small"
				@keyup.enter.native="handleReset">
				<i slot="suffix" class="el-icon-view el-input__icon" @click="showPassword1" />
			</el-input>
		</el-form-item>
		<el-form-item prop="password2">
			<el-input
				v-model="resetForm.password2"
				:type="password2Type"
				auto-complete="off"
				placeholder="请确认密码"
				prefix-icon="el-icon-lock"
				size="small"
				@keyup.enter.native="handleReset">
				<i slot="suffix" class="el-icon-view el-input__icon" @click="showPassword2" />
			</el-input>
		</el-form-item>
		<el-form-item>
			<el-button class="login-submit" size="small" type="primary" @click.native.prevent="handleReset">
				重置密码
			</el-button>
		</el-form-item>
	</el-form>
</template>

<script>
import {mapGetters} from 'vuex'
import {rule} from '@/util/validateRules'

export default {
	name: 'resetPassword',
	components: {},
	data() {
		return {
			resetForm: {
				password1: '',
				password2: '',
			},
			checked: false,
			resetRules: {
				password1: [
					{required: true, message: '请输入密码', trigger: 'blur'},
					{validator: rule.validatorPass, trigger: 'blur'},
				],
				password2: [
					{required: true, message: '请确认密码', trigger: 'blur'},
					{validator: rule.validatorPass, trigger: 'blur'},
				],
			},
			password1Type: 'password',
			password2Type: 'password',
		}
	},
	computed: {
		...mapGetters(['tagWel']),
	},
	methods: {
		showPassword1() {
			this.password1Type == '' ? (this.password1Type = 'password') : (this.password1Type = '')
		},
		showPassword2() {
			this.password1Type == '' ? (this.password2Type = 'password') : (this.password2Type = '')
		},
		handleReset() {
			this.$store.dispatch('ResetPassword', this.resetForm).then(() => {
				this.$router.push({path: this.tagWel.value})
			})
		},
	},
}
</script>

<style></style>
